export default __webpack_public_path__ + "static/media/trophy_circles.dd8f9dbf.png";